module.exports = __webpack_public_path__ + "static/media/CustomIconMathBig.ab9d5a94.svg";